import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

export const { Types, Creators } = createActions({
    dateEventsRequest: [],
    getDateEvents: ['data'],
    dateEventsSuccess: ['data'],
    dateEventsError: ['err']
  });
  
  /* Initial State */
  
  export const INITIAL_STATE = Immutable({
    data: [],
    loading: false,
    error: false
  });
  
  /* Reducers */
  
  export const request = state => state.merge({ loading: true });
  
  export const success = (state, { data }) => state.merge({ data, error: false, loading: false });
  
  export const error = state => state.merge({ loading: false, error: true });
  
  /* Reducers to types */
  
  export default createReducer(INITIAL_STATE, {
    [Types.DATE_EVENTS_REQUEST]: request,
    [Types.DATE_EVENTS_SUCCESS]: success,
    [Types.DATE_EVENTS_ERROR]: error
  });